import { startPartnerDetection } from "./partner-detection.js";
export async function start(parameters) {
    void startPartnerDetection(parameters);
}
